<div mat-dialog-title class="title">
  <h2>{{ (data.textKey | locLabel) || data.text }}</h2>
</div>
<div class="decision-buttons" mat-dialog-content>
  <button mat-stroked-button class="fliko-stroked-button-filled" [class.offers]="data.colors === ColorSchemes.OFFERS" color="primary" type="button" [mat-dialog-close]="true">
    {{ data.acceptKey | locCap }}
  </button>
  <button
    mat-stroked-button
    class="fliko-stroked-button"
    [class.offers]="data.colors === ColorSchemes.OFFERS"
    color="primary"
    type="button"
    [mat-dialog-close]="false"
    *ngIf="data.cancelKey"
  >
    {{ data.cancelKey | locCap }}
  </button>
</div>
